var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineTagRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2532E712-1D14-4366-9523-91983F8CAA01") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Essetional",
    transform: "translate(-300.000000, -636.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tag-right",
    transform: "translate(300.000000, 636.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.21942687,21.6500969 C3.11942685,21.6500969 2.14945135,21.0800981 1.61945137,20.1200981 C1.0894514,19.1600981 1.11946848,18.0300977 1.69946846,17.1000977 L4.46942687,12.6700974 C4.68942687,12.3200974 4.68942687,11.6700972 4.46942687,11.3300972 L1.69946846,6.90009785 C1.11946848,5.97009784 1.0894514,4.84009784 1.61945137,3.88009787 C2.14945135,2.92009789 3.12942684,2.35009766 4.21942687,2.35009766 L15.6594296,2.35009766 C16.5994295,2.35009766 17.6894491,2.95009774 18.1794491,3.75009775 L22.3594418,10.4300976 C22.9194418,11.3300976 22.8694369,12.7100986 22.2294369,13.5600986 L17.0494442,20.4600964 C16.5394442,21.1400964 15.5194393,21.6500969 14.6694393,21.6500969 L4.21942687,21.6500969 Z M2.92944896,4.61009789 C2.66944897,5.09009787 2.679427,5.65009788 2.96942699,6.11009789 L5.73944664,10.5400982 C6.25944662,11.3800982 6.25944662,12.6400968 5.73944664,13.4800968 L2.96942699,17.9100971 C2.679427,18.3700971 2.66944897,18.9300971 2.92944896,19.4100971 C3.18944895,19.8900971 3.67942685,20.1700974 4.21942687,20.1700974 L14.6694393,20.1700974 C15.0494393,20.1700974 15.619432,19.8800972 15.849432,19.5800972 L21.0294857,12.6800976 C21.2994857,12.3200976 21.3294833,11.6300973 21.0894833,11.2500973 L16.9094296,4.57009792 C16.6894296,4.21009791 16.0794295,3.88009787 15.6594296,3.88009787 L4.21942687,3.88009787 L4.21942687,3.85009766 C3.67942685,3.85009766 3.18944895,4.1300979 2.92944896,4.61009789 Z",
    id: "Vector",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,0 L24,24 L0,24 L0,0 L24,0 Z",
    id: "Vector",
    opacity: 0
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineTagRight);
export default __webpack_public_path__ + "static/media/vuesax-outline-tag-right.2de4e711c745499502acc5e3f14a9993.svg";
export { ForwardRef as ReactComponent };